export type Theme = 'light' | 'dark' | 'system';

const KEY = 'qm-theme';

export function getStoredTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function resolveTheme(t: Theme): 'light' | 'dark' {
  if (t === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return t;
}

export function applyTheme(t: Theme) {
  const resolved = resolveTheme(t);
  document.documentElement.classList.toggle('dark', resolved === 'dark');
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* Safari private mode — accept ephemeral state */
  }
}
